import { render, staticRenderFns } from "./pinglun.vue?vue&type=template&id=55649740"
import script from "./pinglun.vue?vue&type=script&lang=js"
export * from "./pinglun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports